<template>
  <a-drawer v-model:visible="showDialog"
            width='50%'
            :title="$t('order.AfterSale.afterSaleRefund')"
            placement="right"
            :destroy-on-close="true"
            @close="closeClick">
    <a-form ref="afterSaleForm"
            :model="formState"
            autocomplete="off">
      <a-form-item :label="$t('order.AfterSale.refundGoods')"
                   name="refund_reason"
                   :rules="[{ required: true, message: $t('order.AfterSale.pleaseChooseGoods') }]">
        <div v-if="props.afterType == 'add'"
             style="text-align: center;">
          <a-button type="primary"
                    @click="chooseCustom">{{ $t('order.AfterSale.chooseGoods') }}</a-button>
        </div>
        <div v-if="selectedData.length > 0"
             class="custom-content">
          <div v-for="record in selectedData"
               class="custom-box">
            <div class="flex-box">
              <div ref="hiddenContainer"
                   class="hidden"></div>
              <div class="image-box">
                <div v-if="hiddenContainer && record.is_custom"
                     class="viewer">
                  <image-customize-viewer :id="record.id + ''"
                                          mode="view"
                                          :container="hiddenContainer"
                                          :template-basic-parameters="templateBasicParameters(renderImageBaseUrl(record), colorOfItem(record)?.value, record.spu_custom_width, record.spu_custom_height)"
                                          :custom-area="assignCustomizedData(record.spu_custom_areas, record.spu_custom_width, record.customSpu?.customizedImages[theFirstCustomizedArea(record)]?.customized_areas.customable_image_scale, record.customSpu?.customizedImages[theFirstCustomizedArea(record)]?.customized_areas.boundingRect)"
                                          :customized-image="renderImageCustomUrl(record)" />
                </div>
                <img v-else
                     :src="toUrl(record.image)"
                     class="viewer" />
              </div>
              <div class="item-flex">
                <div class="name_color">
                  {{ record.spu_name }}
                </div>
                <div class="attr_box">
                  <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                        :key="index">
                    {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              {{ $t('order.AfterSale.quality') }}：{{ record.refundQuality }}
            </div>
          </div>
          <div>
          </div>
        </div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refundAmount')"
                   name="refund_amount"
                   :rules="[{ required: true, message: $t('order.AfterSale.enterAmount') }]">
        <div style="color: #de4a09;display: inline-block;">{{ formState.refund_amount }}</div>
        <a-popover placement="right">
          <template #content>
            <div>{{ $t('order.AfterSale.refundCustomAmount') }}：{{ refund_amount }}</div>
            <div>{{ $t('order.AfterSale.refundExpressAmount') }}：{{ refund_express }}</div>
            <div>{{ $t('order.AfterSale.refundDesignAmount') }}：{{ refund_design_amount }}</div>
          </template>
          <QuestionCircleOutlined v-if="!(props.afterType == 'edit' && !props.data.refunds[0].refund_amount_detail)"
                                  :style="{ color: '#999', margin: '0 20px' }" />
        </a-popover>
        <div v-if="couponData.length > 0"
             class="refund_tip">{{ $t('order.AfterSale.couponMsg2') }}{{ couponData.length
            }}{{ $t('order.AfterSale.couponMsg1') }}
        </div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refundReason')"
                   name="refund_reason"
                   :rules="[{ required: true, message: $t('order.AfterSale.enterReason') }]">
        <a-textarea v-if="props.afterType == 'add'"
                    v-model:value="formState.refund_reason"
                    :placeholder="$t('order.AfterSale.enterReason')"
                    maxlength="255"
                    :rows="4" />
        <div v-else>{{ formState.refund_reason }}</div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refundVoucher')"
                   name="refund_images"
                   :rules="[{ required: true, message: $t('order.AfterSale.chooseVoucher') }]">
        <div v-if="props.afterType == 'add'"
             style="display: flex;align-items: flex-end;">
          <a-upload v-model:file-list="fileList"
                    list-type="picture-card"
                    :with-credentials="true"
                    :max-count="5"
                    :action="toUrl('/v1/api/attachment/material')"
                    :before-upload="verifyUploadImgName"
                    @change="handleChange"
                    @preview="handlePreview">
            <div>
              <loading-outlined v-if="imgLoading"
                                class="upload-icon"></loading-outlined>
              <plus-outlined :style="{ fontSize: '26px', color: '#999' }" />
              <div :style="{ fontSize: '13px', color: '#999', lineHeight: '14px' }">{{ $t('order.AfterSale.upload') }}
              </div>
              <div :style="{ fontSize: '13px', color: '#999', lineHeight: '14px' }">{{ $t('order.AfterSale.uploadMsg')
                }}
              </div>
            </div>
          </a-upload>
        </div>
        <div v-else
             class="image-upload-box">
          <div v-for="(img, index) in fileList"
               :key="index"
               @click="checkImage(img.url)">
            <img :src="img.url"
                 class="img-upload">
          </div>
        </div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refundPhoneNumber')"
                   name="refund_phone"
                   :rules="[{ required: true, validator: validateMobile }]">
        <a-input v-if="props.afterType == 'add'"
                 v-model:value="formState.refund_phone"
                 :placeholder="$t('order.AfterSale.enterNumber')" />
        <div v-else>{{ formState.refund_phone }}</div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refunderName')"
                   name="refund_phone"
                   :rules="[{ required: true, message: $t('order.AfterSale.enterName') }]">
        <a-input v-if="props.afterType == 'add'"
                 v-model:value="formState.refund_name"
                 :placeholder="$t('order.AfterSale.enterName')" />
        <div v-else>{{ formState.refund_name }}</div>
      </a-form-item>
      <a-form-item :label="$t('order.AfterSale.refundType')"
                   name="refund_type"
                   :rules="[{ required: true, message: $t('order.AfterSale.chooseRefundType') }]">
        <a-select v-if="props.afterType == 'add'"
                  v-model:value="formState.refund_type">
          <a-select-option :value="1">{{ $t('order.AfterSale.onlyRefund') }}</a-select-option>
          <a-select-option :value="2">{{ $t('order.AfterSale.returnAndRefund') }}</a-select-option>
        </a-select>
        <div v-else
             class="type-address">
          <div>{{ formState.refund_type == 1 ? $t('order.AfterSale.onlyRefund') : $t('order.AfterSale.returnAndRefund')
            }}
          </div>
          <div v-if="formState.refund_type == 2"
               style="color: #999;margin: 0 10px;font-size: 13px;">
            {{ $t('order.AfterSale.receivingAddress') }}
          </div>
        </div>
      </a-form-item>
      <a-form-item v-if="props.isAdmin && refund_status == 1"
                   :label="$t('order.AfterSale.remark')"
                   name="refund_type"
                   :rules="[{ required: true }]">
        <a-textarea v-model:value="refund_remark"
                    :placeholder="$t('order.AfterSale.enterRemark')"
                    maxlength="255"
                    :rows="3" />
      </a-form-item>
      <a-form-item v-if="refund_status != 1"
                   :label="$t('order.AfterSale.remark')"
                   name="refund_type"
                   :rules="[{ required: true }]">
        <div>{{ refund_remark }}</div>
      </a-form-item>
      <a-form-item v-if="props.afterType == 'edit'"
                   :label="$t('order.AfterSale.refundStatus')"
                   name="refund_type"
                   :rules="[{ required: true }]">
        <div v-if="refund_status == 1">{{ $t('order.AfterSale.inProgress') }}</div>
        <div v-if="refund_status == 2">{{ $t('order.AfterSale.refunded') }}</div>
        <div v-if="refund_status == 3">{{ $t('order.AfterSale.refundRejected') }}</div>
        <div v-if="refund_status == 4">{{ $t('order.AfterSale.afterSaleReturn') }}</div>
      </a-form-item>
      <a-form-item v-if="!props.isAdmin && refund_status == 4 && !formState.express_number && formState.refund_type == 2"
                   :label="$t('order.AfterSale.returnNumber')"
                   name="refund_type"
                   :rules="[{ required: true }]">
        <a-input v-model:value="express_number"
                 :placeholder="$t('order.AfterSale.expressNumber')" />
      </a-form-item>
      <a-form-item v-if="formState.express_number"
                   :label="$t('order.AfterSale.returnNumber')"
                   name="refund_type"
                   :rules="[{ required: true }]">
        <div>{{ express_number }}</div>
      </a-form-item>
    </a-form>
    <template #footer>
      <div style="float: right;">
        <a-button v-if="props.afterType == 'add'"
                  type="primary"
                  style="margin-right: 10px"
                  @click="submit">{{ $t('order.AfterSale.submitAfterSale') }}</a-button>
        <a-button v-if="refund_status == 1 && props.isAdmin"
                  type="primary"
                  style="margin-right: 10px"
                  @click="submitSuccess">{{ $t('order.AfterSale.afterSaleRefund') }}</a-button>
        <a-button v-if="refund_status == 4 && props.isAdmin"
                  type="primary"
                  style="margin-right: 10px"
                  @click="submitSuccess">{{ $t('order.AfterSale.confirmReceipt') }}</a-button>
        <a-button v-if="props.afterType == 'edit' && refund_status == 1 && props.isAdmin"
                  type="primary"
                  @click="refuse">{{ $t('order.AfterSale.rejectAfterSale') }}</a-button>
        <a-button v-if="props.afterType == 'edit' && refund_status != 2 && !props.isAdmin"
                  type="primary"
                  style="margin-right: 10px"
                  @click="cancel">{{ $t('order.AfterSale.cancelAfterSale') }}</a-button>
        <a-button v-if="refund_status == 4 && !props.isAdmin && !formState.express_number && formState.refund_type == 2"
                  type="primary"
                  style="margin-right: 10px"
                  @click="submitExpress">{{ $t('order.AfterSale.submit') }}</a-button>
        <a-button v-if="refund_status != 1"
                  type="primary"
                  @click="closeClick">{{ $t('order.AfterSale.close') }}</a-button>

      </div>
    </template>
    <!-- 删除弹框 -->
    <a-modal v-model:visible="deleteVisible"
             :title="$t('order.AfterSale.cancelAfterSale')"
             @ok="onDeleteOk"
             @cancel="deleteVisible = false">
      <p class="content-size">{{ $t('order.AfterSale.cancelAfterSaleMsg') }}</p>
    </a-modal>
    <!-- 删除弹框 -->
    <a-modal v-model:visible="submitVisible"
             :title="$t('order.AfterSale.submitSale')"
             @ok="onSubmitOk"
             @cancel="submitVisible = false">
      <p class="content-size"> {{ $t('order.AfterSale.submitSaleMsg') }}</p>
    </a-modal>
    <a-modal v-model:visible="imgVisible"
             :title="$t('order.AfterSale.viewImage')"
             @ok="imgVisible = false"
             @cancel="imgVisible = false">
      <img :src="imgDetail"
           class="img-modle-upload ">
    </a-modal>
    <a-modal v-model:visible="customVisible"
             :title="$t('order.AfterSale.selectGoods')"
             :entered='true'
             :cancel-text="$t('order.AfterSale.back')"
             width="1200px"
             :destroy-on-close="true"
             :body-style="{ padding: 0, height: '600px' }"
             @ok="customOk">
      <div class="after-sale-drawer">
        <div ref="hiddenContainer"
             class="hidden"></div>
        <a-table class="settle-table"
                 :scroll="{ y: 400 }"
                 :row-selection="{ selectedRowKeys: selectedRow, type: 'checkbox', onChange: onSelectChange }"
                 :columns="afterColumns"
                 :data-source="itemData"
                 :pagination="false"
                 row-key="id">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'customImages'">
              <div class="flex-box">
                <div class="image-box">
                  <div v-if="hiddenContainer && record.is_custom"
                       class="viewer">
                    <image-customize-viewer :id="record.id + ''"
                                            mode="view"
                                            :container="hiddenContainer"
                                            :template-basic-parameters="templateBasicParameters(renderImageBaseUrl(record), colorOfItem(record)?.value, record.spu_custom_width, record.spu_custom_height)"
                                            :custom-area="assignCustomizedData(record.spu_custom_areas, record.spu_custom_width, record.customSpu?.customizedImages[theFirstCustomizedArea(record)]?.customized_areas.customable_image_scale, record.customSpu?.customizedImages[theFirstCustomizedArea(record)]?.customized_areas.boundingRect)"
                                            :customized-image="renderImageCustomUrl(record)" />
                  </div>
                  <img v-else
                       :src="toUrl(record.image)"
                       class="viewer" />
                </div>
                <div class="item-flex">
                  <div class="name_color">
                    {{ record.spu_name }}
                  </div>
                  <div class="attr_box">
                    <span v-for="(attr, index) in convertAttrs(record.sku_attrs)"
                          :key="index">
                      {{ attr.name }}:<span class="attr_color">{{ attr.value }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'price'">
              <div style="color: #de4a09;">{{ calcPrice.calcSinglePrice(record.price_detail, true) }}</div>
            </template>
            <template v-if="column.dataIndex === 'refundQuality'">
              <a-input-number id="inputNumber"
                              v-model:value="record.refundQuality"
                              :max="record.quality"
                              :min="1"
                              @change="changeQuality(record.refundQuality, record.id)" />
            </template>
            <template v-if="column.dataIndex === 'payPrice'">
              <div v-if="!props.data.is_sale">
                <div v-for="price in discount?.itemDiscount"
                     :key="price.item_id">
                  <div v-if="record.id == price.item_id"
                       style="color: #de4a09;">
                    <div>{{ price.amount
                    }}</div>
                    <div v-if="price.discountPrice != 0">{{ $t('order.AfterSale.couponDiscount') }}{{
                      price.discountPrice
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div>{{ $t('order.AfterSale.adjustPrice') }}
                  <span style="color: #de4a09;">{{ record.adjust_price }}</span>
                </div>
                <div>{{ $t('order.AfterSale.adjustPriceRate') }}<span style="color: #de4a09;">{{ record.rate }}%</span>
                </div>
              </div>
            </template>
            <template v-if="column.dataIndex === 'designPrice'">
              <div>{{ record.orderDssItems.length > 0 ? record.dssPrice : '无' }}</div>
            </template>
          </template>
          <template #footer>
            <a-descriptions :column="2">
              <a-descriptions-item :label="$t('order.AfterSale.actualPayment')">
                <span v-if="props.data.adjustPrice"
                      style="color: #de4a09">{{ props.data.adjustPrice?.pay_amount }}</span>
                <span v-else-if="props.data.is_sale"
                      style="color: #de4a09">{{ props.data.sale?.pay_amount }}</span>
                <span v-else
                      style="color: #de4a09">{{ props.data?.pay_amount }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('order.AfterSale.postage')">{{ props.data.express_fee
              }}</a-descriptions-item>
              <a-descriptions-item v-if="props.data.is_sale"
                                   :label="$t('order.AfterSale.salesAdjustment')">{{ props.data.sale?.pay_amount
                                  }}</a-descriptions-item>
              <a-descriptions-item v-if="props.data.is_sale"
                                   :label="$t('order.AfterSale.salesAdjustmentRate')">{{ props.data.sale?.rate
                                  }}%</a-descriptions-item>
              <a-descriptions-item v-if="props.data.adjustPrice"
                                   :label="$t('order.AfterSale.backendAdjustment')">{{
                                    props.data.adjustPrice?.pay_amount
                                  }}</a-descriptions-item>
              <a-descriptions-item v-if="props.data.adjustPrice"
                                   :label="$t('order.AfterSale.backendAdjustmentRate')">
                {{ new
                  BigNumber(props.data.adjustPrice.pay_amount).div(props.data.adjustPrice?.original_amonut).times(100).toFixed(2)
                }}%
              </a-descriptions-item>
              <a-descriptions-item :label="$t('order.AfterSale.goodsRefundAmount')"
                                   :span="2">
                <span style="color: #de4a09;">{{ refund_amount
                }}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('order.AfterSale.freightRefund')">
                <div style="display:flex;align-items:baseline">
                  <span style="color: #de4a09;">{{ refund_express }}</span>
                  <a-popover placement="right">
                    <template #content>
                      <div>{{ $t('order.AfterSale.expressMsg') }}</div>
                    </template>
                    <QuestionCircleOutlined :style="{ color: '#999', margin: '0 20px' }" />
                  </a-popover>
                </div>
              </a-descriptions-item>
              <a-descriptions-item label="">
                <a-button @click="expressDetailClick">{{ $t('order.AfterSale.viewExpressDetails') }}</a-button>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('order.AfterSale.designRefundAmount')"
                                   :span="2">
                <span style="color: #de4a09;">{{ refund_design_amount
                }}</span>
                <a-popover placement="right">
                  <template #content>
                    <div>{{ $t('order.AfterSale.designMsg') }}</div>
                  </template>
                  <QuestionCircleOutlined :style="{ color: '#999', margin: '0 20px' }" />
                </a-popover>
              </a-descriptions-item>
              <a-descriptions-item v-if="discount?.orderDiscount.discountPrice != 0"
                                   :label="$t('order.AfterSale.couponDiscount')">{{
                                    discount?.orderDiscount.discountPrice
                                  }}</a-descriptions-item>
            </a-descriptions>
          </template>
        </a-table>
        <div v-if="couponData.length > 0">{{ $t('order.AfterSale.couponMsg3') }}：
          <span v-for="coupons in couponData"
                :key="coupons.id">
            {{ $t('order.AfterSale.full') }}{{ coupons.threshold_amount }}
            <span v-if="coupons.discount_amount">{{ $t('order.AfterSale.reduce') }}{{ coupons.discount_amount }}</span>
            <span v-else>{{ $t('order.AfterSale.discount') }}{{ coupons.discount_rate }}</span>
            <span v-if="couponData.length > 1"> ；</span>
          </span>
        </div>
      </div>
    </a-modal>
    <a-modal v-model:visible="addressVisible"
             width="80vw"
             :destroy-on-close="true"
             :title="$t('order.AfterSale.recipientInformation')"
             @cancel="addressVisible = false"
             @ok="addressVisible = false">
      <FlashbaseOrderAddress :order-info="props.data"
                             :is-admin="false" />
    </a-modal>
  </a-drawer>
</template>
<script setup lang="ts">
import { ref, computed, watch } from "vue"
import { type TableColumnType, type FormInstance, type UploadChangeParam, message } from 'ant-design-vue'
import { ImageCustomizeEditor as ImageCustomizeViewer } from '@iota-cn/ui-components'
import { sortBy, renderImageBaseUrl, assignCustomizedData, templateBasicParameters, convertColor, toUrl, verifyUploadImgName } from '@/utils'
import { refundCreate, refundDelete, refundUpdate, refundChange } from "./api/index"
import { Validator } from "@iota-cn/util-validation"
import { DefaultCouponHelper, DefaultCalcPriceHelper } from '@flashbase/util-coupon'
import type { Rule } from "ant-design-vue/lib/form"
import BigNumber from "bignumber.js"
import { useI18n } from "vue-i18n"
const { t } = useI18n()
const coupon = new DefaultCouponHelper()
const calcPrice = new DefaultCalcPriceHelper()

const props = defineProps<{
  visible: boolean
  afterType: string
  isAdmin: boolean
  data: any
}>()
const hiddenContainer = ref()
const showDialog = computed(() => {
  return props.visible
})
const addressVisible = ref<boolean>(false)
const expressDetailClick = () => {
  addressVisible.value = true
}

const itemData = computed(() => {
  const data = [] as any
  props.data.items.forEach((element: any) => {
    let rate = ''
    let adjust_price = ''
    let adjust_rate = ''
    let dssPrice = 0
    if (props.data.is_sale) {
      if (props.data.sale?.salesItems.length > 0) {
        props.data.sale.salesItems.forEach((i: any) => {
          // eslint-disable-next-line no-cond-assign
          if (i.order_item_id == element.id) {
            rate = i.rate
            adjust_price = i.sku_amount
          }
        })
      } else {
        rate = props.data.sale.rate
        const custom = calcPrice.calcSinglePrice(element.price_detail, true) || 0
        adjust_price = new BigNumber(custom).times(element.quality).times(rate).div(100).toFixed(2)
      }
    }
    if (props.data.adjustPrice) {
      adjust_rate = new BigNumber(props.data.adjustPrice.pay_amount).div(props.data.adjustPrice.original_amonut).times(100).toFixed(2)
    }
    if (element.orderDssItems && element.orderDssItems.length > 0) {
      element.orderDssItems.forEach((dss: any) => {
        dssPrice = new BigNumber(dss.unit_price).plus(dssPrice).toNumber()
      })
    }
    data.push(Object.assign(element, { refundQuality: element.quality, rate, adjust_price, adjust_rate, dssPrice }))
  })
  return data
})
const refund_status = ref<number>(1)
watch(() => props.visible, async () => {
  if (props.afterType == 'edit') {
    refund_status.value = props.data.refunds[0].refund_status
    refund_remark.value = props.data.refunds[0].refund_remark
    express_number.value = props.data.refunds[0].refund_express_number
    formState.value.refund_amount = props.data.refunds[0].refund_amount
    formState.value.refund_images = props.data.refunds[0].refund_images
    formState.value.refund_phone = props.data.refunds[0].refund_phone
    formState.value.refund_name = props.data.refunds[0].refund_name
    formState.value.refund_reason = props.data.refunds[0].refund_reason
    formState.value.refund_type = props.data.refunds[0].refund_type
    formState.value.express_number = props.data.refunds[0].refund_express_number
    refund_amount.value = props.data.refunds[0].refund_amount_detail?.refund_amount || 0
    refund_express.value = props.data.refunds[0].refund_amount_detail?.refund_express || 0
    refund_design_amount.value = props.data.refunds[0].refund_amount_detail?.refund_design_amount || 0
    fileList.value = []
    if (props.data.refunds[0].refund_images) {
      const images = props.data.refunds[0].refund_images.split(',')
      images.forEach((img: string) => {
        fileList.value.push({
          url: toUrl(img)
        })
      })
    }
    selectedData.value.length = 0
    const refundItems = props.data.refunds[0].refundItems
    const itemIds = [] as any
    for (const refundItem of refundItems) {
      itemIds.push(refundItem.order_item_id)
    }
    selectedData.value = props.data.items.filter((el: any) => {
      if (itemIds.includes(el.id)) {
        el.refundQuality = el.refundItems[0].quality
      }
      return itemIds.includes(el.id)
    })
    unavailableCoupon.value = props.data.refunds[0].refund_coupon?.split(',')
  } else {
    selectedRow.value = []
    fileList.value = []
    selectedData.value.length = 0
    selectedItems.value.length = 0
    couponData.value.length = 0
    formState.value.refund_amount = 0
    formState.value.refund_phone = ''
    formState.value.refund_name = ''
    formState.value.refund_reason = ''
    formState.value.refund_type = 1
    formState.value.express_number = ''
    props.data.items.forEach((item: any) => {
      item.refundQuality = item.quality
    })
  }
})
const formState = ref({
  refund_phone: '',
  refund_reason: '',
  refund_images: '',
  refund_type: 1,
  refund_amount: 0,
  express_number: '',
  refund_name: ''
})

const express_number = ref<string>('')
const refund_remark = ref<string>('')
const validateMobile = async (_rule: Rule, value: string) => {
  if (!Validator.isPhone(value)) {
    return Promise.reject(new Error(t('order.AfterSale.enterPhoneNumber')))
  }
  return Promise.resolve()
}
const afterColumns = computed<TableColumnType[]>(() => [
  { title: t('order.AfterSale.goods'), dataIndex: 'customImages', align: 'center', width: 350 },
  { title: t('order.AfterSale.goodsQuantity'), dataIndex: 'quality', align: 'center' },
  { title: t('order.AfterSale.goodsUnitPrice'), dataIndex: 'price', align: 'center' },
  { title: t('order.AfterSale.refundQuantity'), dataIndex: 'refundQuality', align: 'center' },
  { title: t('order.AfterSale.originalPayment'), dataIndex: 'payPrice', align: 'center' },
  { title: t('order.AfterSale.designPrice'), dataIndex: 'designPrice', align: 'center' },
])
const renderImageCustomUrl = (record: any) => {

  if (!record.customSpu)
    return

  const scaleRatio = record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas.customable_image_scale || record.spu_custom_areas.scale
  // const heightRatio = Math.round((record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas.boundingRect?.height || record.spu_custom_areas.height) * (200 / record.spu_custom_width) * scaleRatio)
  const widthRatio = Math.round((record.customSpu.customizedImages[theFirstCustomizedArea(record)].customized_areas.boundingRect?.width || record.spu_custom_areas.width) * (200 / record.spu_custom_width) * scaleRatio)
  const renderCustomUrl = toUrl(record.image) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`

  return renderCustomUrl
}

// 临时解决方案 接口返回的customizedImages顺序不一致 order排序以后 sql太长不生效 加入 separate: true会丢失custom spu id 导致数据为空 
const theFirstCustomizedArea = (record: any) => {
  if (record.customSpu && record.customSpu.customizedImages && record.customSpu.customizedImages.length)
    return record.customSpu.customizedImages.reduce((minIdx: number, curr: any, idx: number, array: any[]) => {
      return curr.custom_area_id < array[minIdx].custom_area_id ? idx : minIdx
    }, 0)
  else return 0
}
const colorOfItem = (item: any): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const colorAttr = item.sku_attrs?.find((a: any) => {
    return a.attribute.key === 'color'
  })
  if (colorAttr) {
    return convertColor(colorAttr.value || colorAttr.object_value)
  }
  return undefined
}
const imgDetail = ref<string>('')
const imgVisible = ref<boolean>(false)
const checkImage = (img: any) => {
  imgDetail.value = img
  imgVisible.value = true
}
const convertAttrs = (attrs: any[]) => {
  const arr = [] as any
  attrs.forEach((a) => {
    const data = {
      name: '',
      value: ''
    }
    data.name = a.attribute.name
    data.value = a.object_value ? a.object_value.name : a.value
    arr.push(data)
  })
  arr.sort(sortBy('name', false))
  return arr
}

const customVisible = ref<boolean>(false)
const chooseCustom = () => {
  customVisible.value = true
  if (selectedRow.value.length == 0) {
    caltRefundPrice({
      items: props.data.items,
      selectCoupon: props.data.selectCoupon,
      isUsed: true
    })
  }
  getExpress()
}
const express_fee = ref(0)
const getExpress = () => {
  express_fee.value = 0
  if (props.data.deliver && props.data.deliver.length > 0) {
    props.data.deliver.forEach((item: any) => {
      express_fee.value = new BigNumber(express_fee.value).plus(item.express_fee).toNumber()
    })
  }
}
const customOk = () => {
  selectedData.value = selectedItems.value
  formState.value.refund_amount = new BigNumber(refund_amount.value).plus(refund_express.value).plus(refund_design_amount.value).toNumber()
  // if (formState.value.refund_amount > 1 && props.data.adjustPrice) {
  //   formState.value.refund_amount = new BigNumber(formState.value.refund_amount).integerValue(BigNumber.ROUND_CEIL).toNumber()
  // }
  customVisible.value = false
}
const selectedItems = ref<any[]>([])
const selectedData = ref<any[]>([])
const selectedOrder = ref()
const selectedRow = ref<any[]>([])
// const couponList = ref()
// 购物车表格多选
const onSelectChange = (selectedRowKeys: any[], selectedRows: any[]) => {
  selectedRow.value = selectedRowKeys
  selectedItems.value = selectedRows
  selectDataFetch()
}
const isSelectAll = ref<boolean>(false)
const selectDataFetch = () => {
  let items = props.data.items.filter((el: any) => !selectedRow.value.includes(el.id))
  const selectItem = [] as any
  couponData.value.length = 0
  refund_design_amount.value = 0
  let index = 0
  selectedItems.value.forEach((row: any) => {
    if (row.quality != row.refundQuality) {
      const rowdata = JSON.parse(JSON.stringify(row))
      rowdata.quality = row.quality - row.refundQuality
      selectItem.push(rowdata)
    } else {
      index++
      row.selectCoupon.forEach((coupon: any) => {
        couponData.value.push(coupon)
      })
    }
    if (row.orderDssItems && row.orderDssItems.length > 0) {
      row.orderDssItems.forEach((dss: any) => {
        const dss_amount = new BigNumber(dss.unit_price).times(row.refundQuality).toNumber()
        refund_design_amount.value = new BigNumber(refund_design_amount.value).plus(dss_amount).toNumber()
      })
    }
  })
  items = [...items, ...selectItem]
  selectedOrder.value = {
    selectCoupon: props.data.selectCoupon,
    items,
    isUsed: true
  }
  if (index == itemData.value.length) {
    isSelectAll.value = true
    if (props.data.deliver && props.data.deliver.length > 0) {
      refund_express.value = 0
      selectData.value = JSON.parse(JSON.stringify(selectedItems.value))
      props.data.deliver.forEach((de: any) => {
        if (de.deliver_status == 0) {
          const flag = matchDeliver(de.deliverItems)
          if (flag) {
            refund_express.value = new BigNumber(de.express_fee).plus(refund_express.value).toNumber()
          }
        }
      })
    } else {
      refund_express.value = props.data.status == 6 ? 0 : props.data.express_fee
    }
    if (!props.data.adjustPrice && props.data.is_sale && props.data.sale.salesItems.length == 0) {
      refund_express.value = new BigNumber(refund_express.value).times(props.data.sale.rate).div(100).toFixed(2) as any
    }
    if (props.data.status == 6) {
      refund_amount.value = new BigNumber(props.data.pay_amount).minus(refund_design_amount.value).minus(props.data.express_fee).toNumber()
      formState.value.refund_amount = new BigNumber(props.data.pay_amount).minus(props.data.express_fee).toNumber()
    } else {
      refund_amount.value = new BigNumber(props.data.pay_amount).minus(refund_design_amount.value).minus(refund_express.value).toNumber()
      formState.value.refund_amount = new BigNumber(props.data.pay_amount).minus(refund_express.value).toNumber()
    }
  } else {
    isSelectAll.value = false
    filterRefundPrice(selectedOrder.value)
    caltRefundPrice(selectedOrder.value)
  }
}

const unavailableCoupon = ref<any[]>([])
const filterRefundPrice = (order: any) => {
  try {
    let couponList = [] as any
    const orderdata = JSON.parse(JSON.stringify(order))
    orderdata.selectCoupon = []
    for (let i = 0; i < orderdata.items.length; i++) {
      const item = orderdata.items[i]
      if (item.selectCoupon.length > 0) {
        const itemData = JSON.parse(JSON.stringify(item))
        item.selectCoupon = []
        const orderList = {
          items: [item],
          selectCoupon: [],
          isUsed: true
        }
        const result = coupon.canUseAtItem(orderList, item, itemData.selectCoupon)
        const canFalse = result.filter(el => !el.can)
        couponList = [...couponList, ...canFalse]
      }
    }
    const orderList = {
      items: order.items,
      selectCoupon: [],
      isUsed: true
    }
    const orderResult = coupon.canUseAtOrder(orderList, order.selectCoupon)
    const canFalse = orderResult.filter(el => !el.can)
    couponList = [...couponList, ...canFalse]
    unavailableCoupon.value = couponList.filter((item: any, index: any) => {
      return couponList.indexOf(item) == index
    })
  }
  catch (e) {
    console.log(555, e)
  }
}
const couponData = ref<any[]>([])
const discount = ref()
const caltRefundPrice = (order: any) => {
  const orderdata = JSON.parse(JSON.stringify(order))
  const unavailable = [] as any
  unavailableCoupon.value?.forEach(coupon => {
    unavailable.push(coupon.id)
  })
  orderdata.selectCoupon = orderdata.selectCoupon?.filter((select: any) => {
    if (unavailable.includes(select.id)) {
      couponData.value.push(select)
    }
    return !unavailable.includes(select.id)
  })
  orderdata.items?.forEach((item: any) => {
    item.selectCoupon = item.selectCoupon?.filter((select: any) => {
      if (unavailable.includes(select.id)) {
        couponData.value.push(select)
      }
      return !unavailable.includes(select.id)
    })
  })
  discount.value = coupon.calcDiscount(orderdata)
  console.log('discount', discount.value)
  // if ([3, 4].includes(props.data.status)) {
  //   formState.value.refund_amount = new BigNumber(formState.value.refund_amount).plus(express_fee).toNumber()
  // }
  couponData.value = deduplication(couponData.value)
  changeRefundAmount()
}
const refund_express = ref(0)
const refund_amount = ref(0)
const refund_design_amount = ref(0)
const changeRefundAmount = () => {
  if (props.data.deliver && props.data.deliver.length > 0) {
    refund_express.value = 0
    selectData.value = JSON.parse(JSON.stringify(selectedItems.value))
    props.data.deliver.forEach((de: any) => {
      if (de.deliver_status == 0) {
        const flag = matchDeliver(de.deliverItems)
        if (flag) {
          refund_express.value = new BigNumber(de.express_fee).plus(refund_express.value).toNumber()
        }
      }
    })
  }
  let costom_price = 0 as any
  let express = props.data.express_fee
  discount.value.itemDiscount.forEach((dis: any) => {
    itemData.value.forEach((item: any) => {
      if (dis.item_id == item.id) {
        if (props.data.is_sale) {
          costom_price = new BigNumber(dis.amount).times(item.rate || 100).div(100).plus(costom_price).toNumber().toFixed(2)
        } else {
          costom_price = new BigNumber(dis.amount).plus(costom_price).toNumber().toFixed(2)
        }
      }
    })
  })
  if (!props.data.adjustPrice && props.data.is_sale && props.data.sale.salesItems.length == 0) {
    refund_express.value = new BigNumber(refund_express.value).times(props.data.sale.rate).div(100).toFixed(2) as any
    express = new BigNumber(props.data.express_fee).times(props.data.sale.rate).div(100).toFixed(2)
  }
  if (props.data.adjustPrice) {
    const total_fee = props.data.adjustPrice.original_amonut
    const custom_fee = new BigNumber(total_fee).minus(props.data.sale.express_fee || props.data.express_fee).toNumber()
    const adjust_rate = new BigNumber(props.data.adjustPrice.pay_amount).div(props.data.adjustPrice.original_amonut).times(100).toFixed(2)
    refund_express.value = new BigNumber(refund_express.value).times(adjust_rate).div(100).toFixed(2) as any
    refund_amount.value = new BigNumber(custom_fee).minus(costom_price).times(adjust_rate).div(100).toFixed(2) as any
  } else {
    refund_amount.value = new BigNumber(props.data.pay_amount).minus(refund_design_amount.value).minus(express).minus(costom_price).toNumber()
  }
  if (!selectedItems.value || selectedItems.value.length == 0) {
    refund_amount.value = 0
  }
  refund_amount.value = new BigNumber(refund_amount.value).isGreaterThan(0) ? refund_amount.value : 0
}
const selectData = ref()
const matchDeliver = (item: any) => {
  let index = 0
  for (let i = 0; i < item.length; i++) {
    const obj1 = item[i]
    // eslint-disable-next-line array-callback-return
    const arr = selectData.value.find((el: any) => {
      return el.id == obj1.order_item_id && el.refundQuality > 0 && new BigNumber(obj1.quality).isLessThanOrEqualTo(el.refundQuality)
    })
    if (arr) index++
  }
  if (index == item.length) {
    for (let i = 0; i < item.length; i++) {
      const data = item[i]
      selectData.value.forEach((el: any) => {
        if (el.id == data.order_item_id) {
          el.refundQuality = new BigNumber(el.refundQuality).minus(data.quality).toNumber()
        }
      })
    }
    return true
  }
  return false
}
const changeQuality = (quality: any, id: any) => {
  selectDataFetch()
}
const deduplication = (arr: any) => {
  const temp = arr
  for (let i = 0; i < temp.length; i++) {
    for (let j = i + 1; j < temp.length; j++) {
      if (temp[i].id === temp[j].id) {
        temp.splice(j, 1)
        j--
      }
    }
  }
  return temp
}
const fileList = ref<any>([])
const imgLoading = ref<boolean>(false)
const handleChange = (info: UploadChangeParam) => {
  if (info.file.status === 'uploading') {
    if (fileList.value.length == 5 && fileList.value[4].status != 'uploading') {
      message.error(t('order.AfterSale.uploadsAllowed'))
      return
    } else {
      imgLoading.value = true
    }
    return
  }
  if (info.file.status === 'done') {
    imgLoading.value = false
    const imageArr = [] as any
    fileList.value?.forEach((file: any) => {
      imageArr.push(file.status == 'done' ? file.response.uploaded : file.url)
    })
    formState.value.refund_images = imageArr.join()
  }
  if (info.file.status === 'error') {
    imgLoading.value = false
    message.error(t('order.AfterSale.errMsg1'))
  }
}
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  imgDetail.value = file.url || file.preview
  imgVisible.value = true
}
const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
const emit = defineEmits(['afterChange'])
const closeClick = async () => {
  emit('afterChange', false)
  selectedRow.value = []
  selectedData.value.length = 0
  selectedItems.value.length = 0
  couponData.value.length = 0
  formState.value.refund_amount = 0
  formState.value.refund_phone = ''
  formState.value.refund_name = ''
  formState.value.refund_reason = ''
  formState.value.refund_type = 1
  formState.value.express_number = ''
  fileList.value = []
  props.data.items.forEach((item: any) => {
    item.refundQuality = item.quality
  })
  refund_express.value = 0
  refund_amount.value = 0
  refund_design_amount.value = 0
}
const afterSaleForm = ref<FormInstance>()
const submitExpress = async () => {
  if (!express_number.value) {
    message.error(t('order.AfterSale.enterOrderNumber'))
  } else {
    await refundUpdate(props.data.refunds[0].id, { refund_express_number: express_number.value }).then(() => {
      message.success(t('order.AfterSale.success1'))
    }).catch(() => {
      message.error(t('order.AfterSale.errMsg2'))
    })
    // closeClick()
  }
}
const submitVisible = ref<boolean>(false)
const submitSuccess = async () => {
  submitVisible.value = true
}
const onSubmitOk = async () => {
  if (formState.value.refund_type == 2 && refund_status.value == 1) {
    await refundUpdate(props.data.refunds[0].id, { refund_remark: refund_remark.value, refund_status: 4 }).then(() => {
      message.success(t('order.AfterSale.success1'))
      closeClick()
    }).catch(() => {
      message.error(t('order.AfterSale.errMsg2'))
    })
  } else {
    await refundChange(props.data.refunds[0].id, { refund_status: 2 }).then(() => {
      message.success(t('order.AfterSale.success2'))
      closeClick()
    }).catch(() => {
      message.error(t('order.AfterSale.errMsg3'))
    })
  }
  submitVisible.value = false
}
const submit = async () => {
  await afterSaleForm.value?.validate().then(async (res: any) => {
    if (res.outOfDate) {
      return
    }
    const items = [] as any
    selectedData.value.forEach((item: any) => {
      items.push({
        quality: item.refundQuality,
        order_item_id: item.id
      })
    })
    const unavailable = [] as any
    unavailableCoupon.value?.forEach(coupon => {
      unavailable.push(coupon.id)
    })
    const data = {
      refund_amount: formState.value.refund_amount,
      refund_images: formState.value.refund_images,
      refund_phone: formState.value.refund_phone,
      refund_name: formState.value.refund_name,
      refund_type: formState.value.refund_type,
      refund_reason: formState.value.refund_reason,
      order_status: props.data.status,
      refund_coupon: unavailable.join(','),
      items,
      coupon: couponData.value,
      refund_amount_detail: {
        refund_amount: refund_amount.value,
        refund_express: refund_express.value,
        refund_design_amount: refund_design_amount.value
      },
    }
    await refundCreate(props.data.id, data).then(() => {
      message.success(t('order.AfterSale.success3'))
    }).catch(() => {
      message.error(t('order.AfterSale.errMsg4'))
    })
    closeClick()
  })
}
const deleteVisible = ref<boolean>(false)
const cancel = () => {
  deleteVisible.value = true
}
const refuse = async () => {
  if (!refund_remark.value) {
    message.error(t('order.AfterSale.enterRefundRemark'))
    return
  }
  await refundUpdate(props.data.refunds[0].id, { refund_remark: refund_remark.value, refund_status: 3 }).then(() => {
    message.success(t('order.AfterSale.success1'))
    closeClick()
  }).catch(() => {
    message.error(t('order.AfterSale.errMsg2'))
  })
}
const onDeleteOk = async () => {
  const id = props.data.refunds[0].id
  await refundDelete(id).then(() => {
    message.success(t('order.AfterSale.success4'))
    closeClick()
  }).catch(() => {
    message.error(t('order.AfterSale.errMsg5'))
  })
  deleteVisible.value = false
}
</script>
<style scoped lang="less">
.after-sale-drawer {
  margin: 20px;

  :deep(.ant-table-tbody) {
    font-size: 13px;
    color: #696768;
  }

  .settle-table {
    border: 1px solid #F1F1F1;
    margin-bottom: 10px;
  }

}

.type-address {
  line-height: 0;
  display: flex;
}

.custom-content {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #e1e1e1;
  margin: 10px;

  .custom-box {
    height: 60px;
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

  }

  .custom-box:hover {
    background-color: #dad2d236;
  }
}

.custom-titile {
  margin: 10px;
}

.flex-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 5px;

  .image-box {
    width: 48px !important;
    height: 48px !important;
    background-color: #F6F6F6;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;

    .hidden {
      width: 48px;
      height: 48px;
      position: absolute;
      visibility: hidden;
      display: block;
    }

    .viewer {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;

      @-moz-document url-prefix() {
        :deep(.fabric-div) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.canvas-container) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.lower-canvas) {
          width: 48px !important;
          height: 48px !important;
        }

        :deep(.upper-canvas) {
          width: 48px !important;
          height: 48px !important;
        }
      }

      :deep(.fabric-div) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.canvas-container) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.lower-canvas) {
        width: 48px !important;
        height: 48px !important;
      }

      :deep(.upper-canvas) {
        width: 48px !important;
        height: 48px !important;
      }
    }
  }

  .item-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    margin-left: 10px;
    text-align: start;

    .name_color {
      font-size: 16px;
    }

    .attr_box {
      word-wrap: break-word;
    }

    .attr_color {
      color: #999;
      margin-right: 5px;
    }
  }
}

.image-upload-box {
  display: flex;

  .img-upload {
    width: 100px;
    height: 100px;
    margin-right: 10px;
  }
}

.img-modle-upload {
  max-width: 450px;
}

.content-size {
  font-size: 16px;
}

.refund_tip {
  color: #999;
  display: inline-block;
  font-size: 13px;
  margin-left: 10px;
}
</style>